var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroupe1680(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 97,
    height: 106,
    viewBox: "0 0 97 106",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1680",
    "data-name": "Groupe 1680",
    transform: "translate(-13228 -1133)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1286",
    "data-name": "Rectangle 1286",
    d: "M0,0H97a0,0,0,0,1,0,0V57.5A48.5,48.5,0,0,1,48.5,106h0A48.5,48.5,0,0,1,0,57.5V0A0,0,0,0,1,0,0Z",
    transform: "translate(13228 1133)",
    fill: "#f3f8ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "vuesax_linear_ranking",
    "data-name": "vuesax/linear/ranking",
    transform: "translate(12766 532)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ranking",
    transform: "translate(492 636)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.213,0H3.062A3.071,3.071,0,0,0,0,3.062v9.187H10.213Z",
    transform: "translate(3.062 21.436)",
    fill: "none",
    stroke: "#1b7afa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M7.151,0H3.062A3.071,3.071,0,0,0,0,3.062V18.374H10.213V3.062A3.061,3.061,0,0,0,7.151,0Z",
    transform: "translate(13.26 15.312)",
    fill: "none",
    stroke: "#1b7afa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M7.151,0H0V7.656H10.213V3.062A3.071,3.071,0,0,0,7.151,0Z",
    transform: "translate(23.473 26.03)",
    fill: "none",
    stroke: "#1b7afa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(13.771 2.517)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M5.4.653l.812,1.623a.925.925,0,0,0,.643.475L8.324,3c.934.153,1.164.842.49,1.5L7.665,5.644a.978.978,0,0,0-.245.827L7.742,7.88C8,9,7.4,9.426,6.425,8.844L5.047,8.033a.946.946,0,0,0-.9,0l-1.378.812c-.98.582-1.577.153-1.317-.965L1.77,6.471a.965.965,0,0,0-.245-.827L.392,4.511c-.674-.674-.459-1.347.49-1.5l1.47-.245A1.02,1.02,0,0,0,3,2.291L3.807.668C4.251-.22,4.955-.22,5.4.653Z",
    fill: "none",
    stroke: "#1b7afa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M0,0H36.748V36.748H0Z",
    fill: "none",
    opacity: 0
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupe1680);
export default __webpack_public_path__ + "static/media/Groupe-1680.83727f89eb22cef58827d29c934fe9a0.svg";
export { ForwardRef as ReactComponent };